export enum CauseAreaSettingsTabs {
  General,
  Instances,
}
